<form *ngIf="contractInboundPhoneFormGroup" [formGroup]="contractInboundPhoneFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="phone">Teléfono</label>
            <input pInputText name="phone"  [pKeyFilter]="phoneFilter" formControlName="phone"   maxlength="20" d-form-field-error />
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && contractInboundPhone.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>